// Het record: de grootste losse verkoop die het dashboard ooit voorbij heeft
// zien komen.
//
// De API geeft alleen totalen per verkoper, geen losse verkopen. Wat één
// verkoop was, weten we dus enkel doordat we twee metingen naast elkaar
// leggen (zie useSaleEvents). Het record bewaren we daarom hier, in de
// browser van de tv, zodat het een herstart of een nieuwe maand overleeft.

const storageKey = "td-sale-record";

export function readRecord() {
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) return null;
    const record = JSON.parse(raw);
    return typeof record?.amount === "number" ? record : null;
  } catch (error) {
    // Privémodus of volle opslag: dan doen we het gewoon zonder record.
    return null;
  }
}

export function writeRecord(record) {
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(record));
  } catch (error) {
    /* niets aan te doen, en het mag het dashboard niet ophouden */
  }
}

export function clearRecord() {
  try {
    window.localStorage.removeItem(storageKey);
  } catch (error) {
    /* zie boven */
  }
}
